<div class="card w-90 overflow-scroll">
    <!-- Card header -->
    <div class="card-header border-0">
      <div class="row w-100 d-flex justify-content-between">
        <div class="">
          <h3 class="mb-0">Submissions</h3>
        </div>
        <div class="">
          <button class="add-item-btn" title="Export" (click)="exportToExcel()" >
            <i class='fas fileicons'>&#xf381;</i> Export
          </button>
        </div>
      </div>
    </div>
    <!-- Light table -->
    <div class="table-responsive">
      <table id="submissionlist" class="table align-items-center table-flush">
        <thead class="thead-light">

          <tr>
            <th class="text-center">S/No</th>
            <th class="text-center">Student</th>
            <th class="text-center">Submitted at</th>
            <th class="text-center">Total Score</th>
            <th class="text-center">Percentage Score</th>
          </tr>
        </thead>
        <tbody>

          <tr *ngFor="let submision of assessmentSubmissionList; let currentIndex = index" routerLink="/user/scoreassessment" [queryParams]="{aid: this.assessmentID, stid : submision.studentid , classid : this.classID,moduleid:this.moduleId, batchid: this.batchID}" class="submission-tr" >
            <td class="text-center">{{currentIndex + 1}}</td>
            <td class="table-user text-center">
              <b>{{submision.studentname}}</b>
            </td>
            <td class="text-center">
              <span class="text-muted">{{submision.submitdate}}</span>
            </td>
            <td class="text-center">
              <span *ngIf="submision.scored">{{submision.score}}/{{submision.totalmarks}}</span>
            </td>
            <td class="text-center">
              <span *ngIf="submision.scored">{{submision.percentagescore}}</span>
            </td>
          </tr>
        </tbody>
        <tfoot>
            <tr>
                <td colspan="12">

                    </td>

            </tr>
        </tfoot>
      </table>
    </div>
  </div>
